/* DSL Quick-add — POST /cart/add.js zonder page reload */
(function(){
  document.addEventListener("click", function(e){
    var b = e.target.closest("[data-quick-add]");
    if (!b) return;
    e.preventDefault();
    var id = b.dataset.quickAdd, qty = b.dataset.quickAddQty || 1;
    b.disabled = true; b.dataset.origLabel = b.textContent; b.textContent = "Toevoegen...";
    fetch("/cart/add.js", {
      method: "POST", headers: {"Content-Type":"application/json", Accept:"application/json"},
      body: JSON.stringify({items: [{id: id, quantity: parseInt(qty, 10)}]})
    }).then(function(r){ return r.json(); }).then(function(item){
      b.textContent = "Toegevoegd ✓";
      if (window.DSL_AB) window.DSL_AB.track("quick_add", {id: id});
      if (window.DSL_CART_DRAWER) setTimeout(window.DSL_CART_DRAWER.open, 200);
      setTimeout(function(){ b.disabled = false; b.textContent = b.dataset.origLabel; }, 1500);
    }).catch(function(){ b.disabled = false; b.textContent = b.dataset.origLabel; });
  });
})();